// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { useFormik } from 'formik';
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Link, useParams } from 'react-router-dom';
// ICONS
// CUSTOM COMPONENTS
import Section from '../../../components/Section';
import ContentBlock from '../../../components/ContentBlock';
import CustomBlock from '../../../components/CustomBlock';
import ContentHeader from '../../../components/ContentHeader';
import SelectBlock from '../../../components/SelectBlock';
import InputBlock from '../../../components/InputBlock';
import Button from '../../../components/Button';
// PARTIALS
// SERVICES AND HELPERS
import * as confirmModal from '../../../../redux/confirmModalRedux';
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as jobFormService from '../../../../services/service/jobFormService';
import * as projectInfoSheetService from '../../../../services/form/projectInfoSheetService';
import ProjectInformationSheetValidator from '../../../../helpers/validators/ProjectInformationSheetValidator';
import ProjectInfoSheetLineItemValidator from '../../../../helpers/validators/ProjectInfoSheetLineItemValidator';

const initialState = {
    id: 0,
    projectLocationId: null,
    initialDateAssigned: null,
    contractor: '',
    contractorPhoneNumber: '',
    contractorAddress: '',
    abatedAmountAndType: '',
    disposalSite: '',
    wastePermit: '',
    projectName: '',
    project: '',
    projectInfoSheetLineItems: []
}

const lineItemInitialState = {
    id: 0,
    name: '',
    aiNumber: '',
    jobTitle: '',
    date: null
}


const ProjectInfoSheet = (props) => {
    const iframeRef = useRef();
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, history, auth } = props;
    const { jobFormId, edit } = useParams();
    const [loading, setLoading] = useState(false);
    const [projectInfoSheet, setProjectInfoSheet] = useState(initialState);
    const [locationOptions, setLocationOptions] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [switchMode, setSwitchMode] = useState(false);
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [lineItem, setLineItem] = useState(lineItemInitialState);
    const [jobForm, setJobForm] = useState({
        id: 0,
        jobFormId: 0,
        projectNumber: "",
        client: "",
        name: "HA PLM Data Sheet",
        actualAssignedDate: null,
        submittedById: 0,
        jobId: 0,
        formLead: '',
        projectInfoSheet: {},
        client: '',
        clientAddress: '',
        clientPhoneNumber: ''
    });

    useEffect(() => {
        setLoading(true);
        if (edit == 'false') {
            setSwitchMode(true)
            getReport(jobFormId)
        }
        else {
            fetchJobLocations().then(locations => {
                fetchProjectInfoSheet(locations);
            });
        }
    }, [])

    const fetchJobLocations = () => jobFormService.getProposalProjectLocationsByJobFormId(jobFormId).then(res => {
        setLocationOptions(res);
        return res;
    });

    const getReport = (id) => {
        if (id) {
            projectInfoSheetService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: projectInfoSheet,
        validationSchema: ProjectInformationSheetValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveForm(values).finally(() => {
                setSubmitting(false)
            });
        }
    });

    const formik_lineItem = useFormik({
        enableReinitialize: true,
        initialValues: lineItem,
        validationSchema: ProjectInfoSheetLineItemValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            setLoading(true);
            saveLineItem(values).finally(() => {
                resetLineItemForm();
                setSubmitting(false)
            });
        }
    });

    const resetLineItemForm = () => {
        formik_lineItem.resetForm();
        setLineItem(lineItemInitialState);
    }

    const saveLineItem = (model) => {
        return projectInfoSheetService.saveLineItem({ ...model, projectInfoSheetId: projectInfoSheet.id, projectInfoSheet: null }).then(res => {
            if (model.id > 0) {
                let temp = [...projectInfoSheet.projectInfoSheetLineItems];
                let indexOfEdited = temp.findIndex(x => x.id === model.id);
                temp[indexOfEdited] = model;
                setProjectInfoSheet({ ...projectInfoSheet, projectInfoSheetLineItems: temp })
            } else {
                setProjectInfoSheet({ ...projectInfoSheet, projectInfoSheetLineItems: [...projectInfoSheet.projectInfoSheetLineItems, { ...model, id: res.id, date: new Date(model.date) }] });
            }

            showAlert({ message: res.message, variant: 'success' });
        });
    }

    const saveForm = (values) => {
        return projectInfoSheetService.save({ ...values, projectInfoSheetLineItems: null,
            ihTechnician: jobForm.projectInfoSheet.ihTechnician ? jobForm.projectInfoSheet.ihTechnician : jobForm.formLead,
            projectLocation: null }).then(res => {
            showAlert({ message: res.message, variant: 'success' });
        });
    }

    const fetchProjectInfoSheet = (projectLocations) => {
        projectInfoSheetService.getProjectInfoSheetById(jobFormId).then(res => {
            if (res.projectInfoSheet.projectLocationId) {
                setSelectedLocation(projectLocations.find(x => x.value == res.projectInfoSheet.projectLocationId));
            }
            setJobForm(res);
            setIsReadOnly(res.submittedById !== 0);
            setProjectInfoSheet(res.projectInfoSheet);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        }).finally(() => setLoading(false));
    }

    const submitForm = () => {
        saveForm(formik.values).then(res => {
            jobFormService.submitForm(jobForm.id).then(res => {
                showAlert({ message: res.message, variant: 'success' });
                history.push("/services/manage-job/forms/" + jobForm.jobId);
            }).catch(ex => {
                showAlert({ message: ex.message, variant: 'error' })
            })
        })
    }

    const columnOptions = {
        filter: true,
        sort: true,
        print: false,
        download: true
    };

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                display: (!auth.isAdmin ? !isReadOnly : true),
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {
                                <CustomBlock className="content-container--actions flex-start pl-0 mt-0">
                                    <Button
                                        text="Edit"
                                        className="info--bg ml-0"
                                        size="xxs"
                                        onClick={() => {
                                            setLineItem(projectInfoSheet.projectInfoSheetLineItems[dataIndex])
                                        }}
                                    />

                                    <Button
                                        text="Delete"
                                        className="danger--bg"
                                        size="xxs"
                                        onClick={() => showConfirmModal({
                                            title: "Delete Line Item",
                                            text: "Are you sure you want to delete this line item?",
                                            rightBtnText: "Confirm",
                                            btnAction: () => removeLineItem(projectInfoSheet.projectInfoSheetLineItems[dataIndex].id)
                                        })}
                                    />
                                </CustomBlock>
                            }

                        </>
                    )
                }
            }

        },
        {
            name: "name",
            label: "Name",
            options: columnOptions
        },
        {
            name: "aiNumber",
            label: "AI No.",
        },
        {
            name: "jobTitle",
            label: "Job Title",
        },
        {
            name: "date",
            label: "Date",
            options: {
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <p>{moment(projectInfoSheet.projectInfoSheetLineItems[dataIndex].date).format("MM/DD/YYYY")}</p>
                    )
                }
            }
        }
    ];

    const removeLineItem = (id) => {
        setLoading();
        setProcessing();
        projectInfoSheetService.deleteLineItem(id).then(res => {
            removeFromLineItemTable(id);
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => {
            hideConfirmModal();
        })
    }

    const removeFromLineItemTable = (id) => {
        let temp = [...projectInfoSheet.projectInfoSheetLineItems];
        let indexOfEdited = temp.findIndex(x => x.id === id);

        if (indexOfEdited > -1) {
            temp.splice(indexOfEdited, 1);
            setProjectInfoSheet({ ...projectInfoSheet, projectInfoSheetLineItems: temp });
        }
    }

    return (
        <>
            {
                switchMode ?
                    (<iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>)
                    :
                    (
                        <>
                            <Section removeContainer>
                                <ContentBlock>
                                    <CustomBlock className="content-container--card-style--with-shadow">
                                        <ContentHeader
                                            title={`Project Information Sheet`}
                                            headerSize="md"
                                            primaryButtonText="Print Form"
                                            primaryButtonBackgroundColor="info--bg mr-0"
                                            primaryButtonOnClick={() => {
                                                setSwitchMode(true);
                                                getReport(jobForm ? jobForm.id : 0)
                                            }}
                                        // secondaryButtonText="Save Changes"
                                        // secondaryButtonBackgroundColor="warning--bg"
                                        />

                                        <CustomBlock>
                                            {/* HEADER SECTION */}
                                            <Section removeContainer className="pb-10">
                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        value={jobForm.projectNumber}
                                                        label="Project Number"
                                                        disabled
                                                    />

                                                </ContentBlock>

                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        value={jobForm.projectInfoSheet.ihTechnician ? jobForm.projectInfoSheet.ihTechnician : jobForm.formLead}
                                                        label="IH Technician"
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Date"
                                                        disabled
                                                        value={moment(jobForm.actualAssignedDate).format("MM/DD/YYYY")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={8}>
                                                    <InputBlock
                                                        label="Client"
                                                        value={jobForm.client}
                                                        disabled
                                                    />
                                                </ContentBlock>


                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Phone Number"
                                                        value={jobForm.clientPhoneNumber}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Address"
                                                        value={jobForm.clientAddress.replace(', ,', ',')}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={8}>
                                                    <InputBlock
                                                        label="Contractor"
                                                        value={jobForm.contractor}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Contractor Phone Number"
                                                        value={jobForm.contractorPhoneNumber}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Contractor Address"
                                                        value={jobForm.contractorAddress}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Project Name"
                                                        value={jobForm.projectName}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={6}>
                                                    <InputBlock
                                                        label="Type of Project"
                                                        value={jobForm.project}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <SelectBlock
                                                        label="Location Address"
                                                        inputState={formik.touched.projectLocationId && formik.errors.projectLocationId ? "error" : ""}
                                                        errorMessage={formik.errors.projectLocationId}
                                                        value={selectedLocation}
                                                        options={locationOptions}
                                                        // disabled={isReadOnly}
                                                        onChange={selectedOption => {
                                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                                            setSelectedLocation(selectedOption);
                                                            formik.setFieldValue("projectLocationId", selectedOption.value);
                                                        }}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={12}>
                                                    <InputBlock
                                                        label="Amount and Type of Material Being Abated"
                                                        name="abatedAmountAndType"
                                                        disabled={isReadOnly}
                                                        id="abatedAmountAndType"
                                                        inputState={formik.touched.abatedAmountAndType && formik.errors.abatedAmountAndType ? "error" : ""}
                                                        errorMessage={formik.errors.abatedAmountAndType}
                                                        {...formik.getFieldProps("abatedAmountAndType")}
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={8}>
                                                    <InputBlock
                                                        label="Disposal Site"
                                                        value={jobForm.disposalSite}
                                                        disabled
                                                    />
                                                </ContentBlock>

                                                <ContentBlock cols={4}>
                                                    <InputBlock
                                                        label="Waste Permit/ADVF"
                                                        value={jobForm.wastePermit}
                                                        disabled
                                                    />
                                                </ContentBlock>
                                            </Section>
                                            {/* LINE ITEM ENTRY */}
                                            <Section removeContainer className="pt-10 pb-10 border-top">

                                                {
                                                    (!auth.isAdmin ?
                                                        !isReadOnly : true) &&
                                                    <>
                                                        <ContentBlock>
                                                            <ContentHeader
                                                                title="Abatement Personnel Information Entry Form"
                                                                headerSize="sm"
                                                                className="fw-700 pb-15"
                                                                primaryButtonText={(formik_lineItem.values.id > 0 ? "Update" : "Add") + " Line Item"}
                                                                secondaryButtonText={'Clear'}
                                                                primaryButtonOnClick={formik_lineItem.submitForm}
                                                                secondaryButtonOnClick={resetLineItemForm}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                isRequired
                                                                label="Name"
                                                                name="name"
                                                                id="name"
                                                                inputState={formik_lineItem.touched.name && formik_lineItem.errors.name ? "error" : ""}
                                                                errorMessage={formik_lineItem.errors.name}
                                                                {...formik_lineItem.getFieldProps("name")}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                isRequired
                                                                label="AI No."
                                                                type="number"
                                                                name="aiNumber"
                                                                id="aiNumber"
                                                                inputState={formik_lineItem.touched.aiNumber && formik_lineItem.errors.aiNumber ? "error" : ""}
                                                                errorMessage={formik_lineItem.errors.aiNumber}
                                                                {...formik_lineItem.getFieldProps("aiNumber")}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                label="Job Title"
                                                                name="jobTitle"
                                                                id="jobTitle"
                                                                inputState={formik_lineItem.touched.jobTitle && formik_lineItem.errors.jobTitle ? "error" : ""}
                                                                errorMessage={formik_lineItem.errors.jobTitle}
                                                                {...formik_lineItem.getFieldProps("jobTitle")}
                                                            />
                                                        </ContentBlock>
                                                        <ContentBlock cols={3}>
                                                            <InputBlock
                                                                isRequired
                                                                type="date"
                                                                label="Date"
                                                                options={{
                                                                    enableTime: false,
                                                                    dateFormat: "m/d/Y",
                                                                }}
                                                                value={moment(formik_lineItem.getFieldProps("date").value).format("MM/DD/YYYY")}
                                                                onChange={date => {
                                                                    formik_lineItem.setFieldValue("date", date[0]);
                                                                }}
                                                            />
                                                        </ContentBlock>
                                                    </>
                                                }

                                                <ContentBlock>
                                                    {/* LINE ITEMS TABLE */}
                                                    <CustomBlock className="content-container--table-container">
                                                        <ContentHeader
                                                            title="Abatement Personnel Information"
                                                            headerSize="md"
                                                            className="fw-700 dark-grey--clr pt-10"
                                                        />

                                                        <MUIDataTable
                                                            data={projectInfoSheet.projectInfoSheetLineItems}
                                                            columns={columns}
                                                            options={{
                                                                selectableRows: "none",
                                                                download: true,
                                                                print: false,
                                                            }}
                                                        />
                                                    </CustomBlock>
                                                </ContentBlock>
                                            </Section>

                                            {/* ACTIONS */}
                                            {
                                                !auth.isAdmin ?
                                                    !isReadOnly &&
                                                    <Section removeContainer className="pt-10">
                                                        <ContentBlock className="content-container--actions">
                                                            <Button
                                                                text="Save Changes"
                                                                className="warning--bg"
                                                                onClick={formik.submitForm}
                                                            />

                                                            <Button
                                                                text="Submit Form"
                                                                onClick={submitForm}
                                                                className="success--bg"
                                                            />
                                                        </ContentBlock>
                                                    </Section>
                                                    :
                                                    <Section removeContainer className="pt-10">
                                                        <ContentBlock className="content-container--actions">
                                                            <Button
                                                                text="Save Changes"
                                                                className="warning--bg"
                                                                onClick={formik.submitForm}
                                                            />
                                                            {
                                                                !isReadOnly &&
                                                                <Button
                                                                    text="Submit Form"
                                                                    onClick={submitForm}
                                                                    className="success--bg"
                                                                />
                                                            }

                                                        </ContentBlock>
                                                    </Section>
                                            }
                                        </CustomBlock>
                                    </CustomBlock>
                                </ContentBlock>
                            </Section>
                        </>
                    )
            }
        </>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(ProjectInfoSheet);